"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _ActionButton = _interopRequireDefault(require("../../ActionButton")),
    _styles = require("../styles"),
    MISSING_HISTORY_ERR = "The History object prop is required in <ClosablePage> when no onClose prop is passed. Pass history down by using the withRouter decorator from react-router-dom.";

function ClosablePage(a) {
  var b = a.children,
      c = a.className,
      d = a.history,
      e = a.onClose,
      f = a.backUrl,
      g = a.backgroundImage,
      h = a.isRootPush;
  if (!d && !e) throw new Error(MISSING_HISTORY_ERR);

  var i = function i(a) {
    return a && a();
  };

  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])("closable-page", (0, _styles.CLOSABLE_PAGE)({
      backgroundImage: g
    }), c)
  }, _react["default"].createElement("div", {
    className: (0, _styles.CLOSABLE_PAGE_HEADER)({
      backgroundImage: g
    })
  }, _react["default"].createElement(_ActionButton["default"], {
    className: (0, _classnames["default"])("closable-page__close-btn", (0, _styles.CLOSE_BUTTON)({
      backgroundImage: g
    })),
    icon: "close",
    iconColor: "regent",
    labelText: "Close",
    onClick: function handleClose() {
      if (!d) return void i(e);
      var a = d.goBack,
          b = d.push,
          c = d.rootPush;
      if (!f) return i(e), void a();
      var g = h && c ? c : b;
      i(e), g(f);
    },
    iconSize: 15
  })), _react["default"].createElement("div", {
    className: (0, _classnames["default"])("closable-page__content", _styles.CONTENT)
  }, b));
}

ClosablePage.defaultProps = {
  isRootPush: !1
};

var _default = (0, _react.memo)(ClosablePage);

exports["default"] = _default;